import { render, staticRenderFns } from "./AwardStep.vue?vue&type=template&id=582f0b0f&scoped=true&"
import script from "./AwardStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardStep.vue?vue&type=style&index=0&id=582f0b0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f0b0f",
  null
  
)

export default component.exports